import { authorizedAPI } from '@/config/axios.config';

export type UptimeRange = '24h' | '7d' | '30d';

export interface UptimeBucket {
  ts: string;
  up: boolean;
}

export interface UptimeHistoryResponse {
  currentStatus: 'UP' | 'DOWN';
  lastHeartbeatAt: string | null;
  uptimePct: number;
  buckets: UptimeBucket[];
}

class UptimeService {
  async getHistory(
    subscriptionId: string,
    range: UptimeRange,
  ): Promise<UptimeHistoryResponse> {
    const response = await authorizedAPI.get<UptimeHistoryResponse>(
      '/uptime/history',
      { params: { subscriptionId, range } },
    );
    return response.data;
  }
}

export const uptimeService = new UptimeService();
